angular.module('mailings')

    .controller('MailingTemplatesModalCtrl', ['entity_type', 'entity_type_id', '$scope', '$uibModal', '$uibModalInstance', '$http', 'Restangular', 'LoginService', '$filter', '$timeout', '$rootScope',
        function (entity_type, entity_type_id, $scope, $uibModal, $uibModalInstance, $http, Restangular, LoginService, $filter, $timeout, $rootScope) {

        $scope.search = { mailing_id: null };

            Restangular.all('mailings').getList({ entity_type: null, entity_type_id: null, mailing_type_code : 'EVENTS'}).then(function (mailings) {
            $scope.selectMailings = [];
            angular.forEach(mailings, function (mailing) {
                $scope.selectMailings.push({ id: mailing.id, fullname: mailing.short_title + " - " + mailing.title });
            })
        });

        $scope.saveTemplate = function () {
            Restangular.all("Mailings").customPOST({}, "SaveMailingFromTemplateToEvent", { mailing_id: $scope.search.mailing_id, entity_type, entity_type_id }).then(function (results) {
                $uibModalInstance.close(results);
            });
        };

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }])
;